// extracted by mini-css-extract-plugin
module.exports = {"container":"organization_container__WksNq","title":"organization_title__1mMCj","content":"organization_content__2H8fG"};